import api from 'api';
import { getCreateCustomerFn } from 'utils/callableFunctions';
import { getBooleanFlag } from 'utils/flags';
import { ResponseOrError, wrapError, wrapSuccess } from 'lib/types/responses';
import { safeAsync } from 'lib/safeWrappers';
import { LaunchDarklyFlags } from 'lib/types/launchDarklyFlags';
import { StripeCustomerAddress } from 'services/billing';

export const createStripeCustomer = async (
  name: string,
  email: string,
  firestoreUID: string,
  address?: StripeCustomerAddress | {}
): Promise<ResponseOrError<string>> => {
  const useCloudRunCreateStripeCustomer = getBooleanFlag(
    LaunchDarklyFlags.USE_CLOUD_RUN_CREATE_STRIPE_CUSTOMER,
    false
  );
  const params = {
    name,
    email,
    firestoreUID,
    address
  };

  if (useCloudRunCreateStripeCustomer) {
    const { error, response } = await api.safePost<'stripe/customer/create'>(
      'stripe/customer/create',
      params
    );

    if (error || !response?.success) {
      return wrapError(new Error('Unable to create new Stripe customer ID'));
    }

    return wrapSuccess(response.stripeId);
  }

  const createCustomer = getCreateCustomerFn();
  const [error, result] = await safeAsync(
    async () => await createCustomer(params)
  )();

  if (error) {
    return wrapError(error);
  }

  if (!result) {
    return wrapError(new Error('Unable to create new Stripe customer ID'));
  }

  return wrapSuccess(result.data.stripeId as string);
};
